import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const INTEGRATIONS = (params) => URI(`${API_BASE}/api/v2/marketplace/integrations/`).addSearch(params)
